"use client";

import { FC } from "react";
import {
  LoadingSpinner,
} from "apps/website/components/form/LoadingSpinner/LoadingSpinner";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import { TFunctionOf } from "apps/website/types/i18n";

interface SignupLoadingScreenProps {
  t: TFunctionOf<"Shared.Actions">
}

export const SignupLoadingScreen: FC<SignupLoadingScreenProps> = ({ t }) => (
  <div className="fixed inset-0 flex flex-col justify-center items-center gap-4">
    <LoadingSpinner color="black" size={32} />
    <TextSubtitle size={4}>{ t("loading") }</TextSubtitle>
  </div>
);
